import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="users"
export default class extends Controller {
  connect() {
    console.log("connected users")

    if(document.getElementById('renewal_date')){
      this.calculateRenewalDate()
    }
  }

  calculateRenewalDate() {
    var remaining_months = document.getElementById('user_remaining_months').value
    var current_year_start = document.getElementById('user_current_start_date').value

    $.ajax({
      type: "GET",
      url: '/users/calculate_remaining_months',
      data: { "remaining_months": remaining_months, "current_year_start": current_year_start },
      success: function(data) {

        if(data.status == 200) {
          document.getElementById('renewal_date').value = data.renewal_date
        } else {
          alert("Error Calculating Remaining Months")
        }
      }
    })
  }


  changeMembershipType(event) {
    var item = event.currentTarget

    if(item.value == 'charter_non_profit' || item.value == 'standard_non_profit'){
      document.getElementById('user_remaining_months').value = 23
    } else {
      document.getElementById('user_remaining_months').value = 11
    }

    this.calculateRenewalDate()
  }

  changePermission(event) {
    var item = event.currentTarget
    const selectElement = document.getElementById('user_status');

    if(item.value == 'host') {
      const targetValue = 'host-hold';

      for (let i = 0; i < selectElement.options.length; i++) {
        if (selectElement.options[i].value === targetValue) {
          selectElement.options[i].selected = true;
          break;
        }
      }
    } else {
      selectElement.removeAttribute('disabled')
      selectElement.options[0].selected = true
    }
  }

  changeStatus(event) {
    var item = event.currentTarget

    document.getElementById('paused_dates_start').classList.add('d-none')
    document.getElementById('paused_dates_end').classList.add('d-none')
    document.getElementById('cancelled_dates').classList.add('d-none')

    if(item.value == 'paused') {
      document.getElementById('paused_dates_start').classList.remove('d-none')
      document.getElementById('paused_dates_end').classList.remove('d-none')
    } 
    
    if(item.value == 'cancelled') {
      document.getElementById('cancelled_dates').classList.remove('d-none')
    }

    if(item.value == 'active') {
      alert("Changing member to active will send them an email noting this change.")
    }
  }

  confirmPassword() {
    var success = document.getElementById('password_success')
    var error = document.getElementById('password_error')
    var password = document.getElementById('user_password')
    var confirm_password = document.getElementById('user_password_confirmation')
    var button = document.getElementById('create_user_button')
    
    if(password.value != confirm_password.value){
      success.classList.add('hidden')
      error.classList.remove('hidden')
      create_user_button.disabled = true
    } else {
      success.classList.remove('hidden')
      error.classList.add('hidden')
      create_user_button.disabled = false
    }
  }

  deleteUser(event) {
    var ans = confirm("Are you sure you want to delete this user?")
    if(ans) {
    } else {
      event.preventDefault()
    }
  }
}
